export default __webpack_public_path__ + "static/media/SkyQ-Tech-Vertical-blue.f8fb3db3.svg";